import type { TLikertType, TSurveyQuestion } from "@/types"

export const NUMBER_TYPES: TSurveyQuestion["type"][] = ["scale", "number"]

export const LIKERT_VARIANTS: Record<TLikertType, any[]> = {
  yes: [
    { value: 100, label: "Yes" },
    { value: 75, label: "Rather yes" },
    { value: 50, label: "Neutral" },
    { value: 25, label: "Rather no" },
    { value: 0, label: "No" },
  ],
  agree: [
    { value: 100, label: "Strongly agree" },
    { value: 75, label: "Agree" },
    { value: 50, label: "Neutral" },
    { value: 25, label: "Disagree" },
    { value: 0, label: "Strongly disagree" },
  ],
  efficiency: [
    { value: 100, label: "Very efficient" },
    { value: 75, label: "Efficient" },
    { value: 50, label: "Neutral" },
    { value: 25, label: "Inefficient" },
    { value: 0, label: "Very inefficient" },
  ],
  satisfaction: [
    { value: 100, label: "Very satisfied" },
    { value: 75, label: "Satisfied" },
    { value: 50, label: "Neutral" },
    { value: 25, label: "Unsatisfied" },
    { value: 0, label: "Very unsatisfied" },
  ],
  frequency: [
    { value: 100, label: "Always" },
    { value: 75, label: "Often" },
    { value: 50, label: "Sometimes" },
    { value: 25, label: "Rarely" },
    { value: 0, label: "Never" },
  ],
}
